// extracted by mini-css-extract-plugin
export default {"list":"ClosureList_list__Ezr5P"};